import { FC, useState } from 'react';
import { Badge, Segmented } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { SmallTooltip } from '@/shared/components/tooltips';

import { FinancialOverviewChartRange } from '../../types';

export const FinancialOverviewChartRangeSegmented: FC<{
    chartRange: FinancialOverviewChartRange;
    marketIsOpen: boolean;
    setChartRange: (range: FinancialOverviewChartRange) => void;
}> = ({ chartRange, marketIsOpen, setChartRange }) => {
    const [disabled] = useState(false);
    const { token } = useAntDesignTheme();

    return (
        <Segmented
            size='small'
            disabled={disabled}
            onChange={(value) => setChartRange(value as FinancialOverviewChartRange)}
            value={chartRange}
            options={[
                {
                    label: 'Real-Time',
                    value: 'realTime',
                    disabled: !marketIsOpen,
                    icon: (
                        <Badge
                            dot
                            style={{ margin: '0 0.25rem' }}
                            color={marketIsOpen ? token.blue6 : token.colorTextSecondary}
                        />
                    ),
                },
                { label: '1D', value: '1D' },
                '1W',
                '1M',
                'QTD',
                '1Q',
                '6M',
                'YTD',
                '1Y',
                '2Y',
                '5Y',
                { label: '10Y', value: '10Y' },
                {
                    label: (
                        <SmallTooltip placement='top' title='30 Years'>
                            Max
                        </SmallTooltip>
                    ),
                    value: 'Max',
                },
            ]}
        />
    );
};
